import type { GroupSecurityValue, SupportedPermissionName } from './types';

export enum GroupSecurity {
  // Patient
  PatientCreate = 'group.security.patient.create',
  PatientRead = 'group.security.patient.read',
  PatientUpdate = 'group.security.patient.update',
  PatientReadAll = 'group.security.patient.read.all',
  // Practitioner
  PractitionerCreate = 'group.security.practitioner.create',
  PractitionerRead = 'group.security.practitioner.read',
  PractitionerUpdate = 'group.security.practitioner.update',
  // Encounter
  EncounterCreate = 'group.security.encounter.create',
  EncounterRead = 'group.security.encounter.read',
  EncounterUpdate = 'group.security.encounter.update',
  // DeviceUseStatement
  DeviceUseStatementCreate = 'group.security.deviceusestatement.create',
  DeviceUseStatementRead = 'group.security.deviceusestatement.read',
  DeviceUseStatementUpdate = 'group.security.deviceusestatement.update',
  // Observation
  ObservationCreate = 'group.security.observation.create',
  ObservationRead = 'group.security.observation.read',
  ObservationUpdate = 'group.security.observation.update',
  // Device
  DeviceCreate = 'group.security.device.create',
  DeviceRead = 'group.security.device.read',
  DeviceUpdate = 'group.security.device.update',
  // Group
  GroupCreate = 'group.security.group.create',
  GroupRead = 'group.security.group.read',
  GroupUpdate = 'group.security.group.update',
  // Organization
  OrganizationCreate = 'group.security.organization.create',
  OrganizationRead = 'group.security.organization.read',
  OrganizationUpdate = 'group.security.organization.update',
  // DiagnosticReport
  DiagnosticReportCreate = 'group.security.diagnosticreport.create',
  DiagnosticReportRead = 'group.security.diagnosticreport.read',
  DiagnosticReportUpdate = 'group.security.diagnosticreport.update',
  // RelatedPerson
  RelatedPersonCreate = 'group.security.relatedperson.create',
  RelatedPersonRead = 'group.security.relatedperson.read',
  RelatedPersonUpdate = 'group.security.relatedperson.update',
  // Coverage
  CoverageCreate = 'group.security.coverage.create',
  CoverageRead = 'group.security.coverage.read',
  CoverageUpdate = 'group.security.coverage.update',
  // ServiceRequest
  ServiceRequestCreate = 'group.security.servicerequest.create',
  ServiceRequestRead = 'group.security.servicerequest.read',
  ServiceRequestUpdate = 'group.security.servicerequest.update',
  ServiceRequestLancet = 'group.security.lancet',

  // Media
  MediaCreate = 'group.security.media.create',
  MediaRead = 'group.security.media.read',
  MediaUpdate = 'group.security.media.update',
  // Medication
  MedicationStatementCreate = 'group.security.medicationstatement.create',
  MedicationStatementRead = 'group.security.medicationstatement.read',
  MedicationStatementUpdate = 'group.security.medicationstatement.update',

  MedicationRequestCreate = 'group.security.medicationrequest.create',
  MedicationRequestRead = 'group.security.medicationrequest.read',
  MedicationRequestUpdate = 'group.security.medicationrequest.update',

  MedicationRequestSignForPractitioner = 'group.security.medicationrequest.sign-for-practitioner',

  ClaimCreate = 'group.security.claim.create',
  ClaimRead = 'group.security.claim.read',
  ClaimUpdate = 'group.security.claim.update',

  ClaimResponseCreate = 'group.security.claimresponse.create',
  ClaimResponseRead = 'group.security.claimresponse.read',
  ClaimResponseUpdate = 'group.security.claimresponse.update',

  ChargeItemDefinitionCreate = 'group.security.chargeitemdefinition.create',
  ChargeItemDefinitionRead = 'group.security.chargeitemdefinition.read',
  ChargeItemDefinitionUpdate = 'group.security.chargeitemdefinition.update',

  // ChargeItem
  ChargeItemCreate = 'group.security.chargeitem.create',
  ChargeItemRead = 'group.security.chargeitem.read',
  ChargeItemUpdate = 'group.security.chargeitem.update',

  // ClinicalImpression
  ClinicalImpressionCreate = 'group.security.clinicalimpression.create',
  ClinicalImpressionRead = 'group.security.clinicalimpression.read',
  ClinicalImpressionUpdate = 'group.security.clinicalimpression.update',
  ClinicalImpressionSummary = 'group.security.clinicalimpression.summary',

  // DeviceMetric
  DeviceMetricCreate = 'group.security.devicemetric.create',
  DeviceMetricRead = 'group.security.devicemetric.read',
  DeviceMetricUpdate = 'group.security.devicemetric.update',
  // ValueSet
  ValueSetIcd10Read = 'group.security.valueset.icd10.read',

  // Task
  TaskCreate = 'group.security.task.create',
  TaskUpdate = 'group.security.task.update',
  TaskRead = 'group.security.task.read',

  // Location
  LocationCreate = 'group.security.location.create',
  LocationUpdate = 'group.security.location.update',
  LocationRead = 'group.security.location.read',

  // Condition
  ConditionCreate = 'group.security.condition.create',
  ConditionUpdate = 'group.security.condition.update',
  ConditionRead = 'group.security.condition.read',

  // Feature Preview
  FeaturePreviewNavigator = 'group.security.featurepreview.navigator',
  FeaturePreviewAISearch = 'group.security.featurepreview.ai.search',
  FeaturePreviewNotes = 'group.security.featurepreview.notes',
  VideoConsultCreate = 'group.security.videoconsult.create',
  VideoConsultInvite = 'group.security.videoconsult.invite',
  FeaturePreviewAuth0 = 'group.security.featurepreview.auth0',
  FeaturePreviewAI = 'group.security.featurepreview.ai',
  FeaturePreviewTracking = 'group.security.featurepreview.tracking',
  AlertEWS = 'group.security.alert.ews',
  AlertTechRead = 'group.security.alert.tech-read',
  AlertCommentRead = 'group.security.alert.comment-read',
  AlertCommentCreate = 'group.security.alert.comment-create',
  Logistics = 'group.security.logistics',
  DeviceConfigure = 'group.security.device.configure',

  ClaimTemplateUpdate = 'group.security.claimtemplate.update',
  ClaimTemplateRead = 'group.security.claimtemplate.read',
  ClaimTemplateCreate = 'group.security.claimtemplate.create',

  // Communication
  CommunicationCreate = 'group.security.communication.create',
  CommunicationRead = 'group.security.communication.read',

  AllergyIntoleranceCreate = 'group.security.allergyintolerance.create',
  AllergyIntoleranceRead = 'group.security.allergyintolerance.read',
  AllergyIntoleranceUpdate = 'group.security.allergyintolerance.update',

  CareTeamRead = 'group.security.careteam.read',
  CareTeamCreate = 'group.security.careteam.create',
  CareTeamUpdate = 'group.security.careteam.update',

  // Library
  LibraryCreate = 'group.security.library.create',
  LibraryUpdate = 'group.security.library.update',
  LibraryRead = 'group.security.library.read',

  Admin = 'group.security.admin',

  CarePlanRead = 'group.security.careplan.read',
  CarePlanCreate = 'group.security.careplan.create',
  CarePlanUpdate = 'group.security.careplan.update',

  PlanDefinitionRead = 'group.security.plandefinition.read',
  PlanDefinitionCreate = 'group.security.plandefinition.create',
  PlanDefinitionUpdate = 'group.security.plandefinition.update',

  ActivityDefinitionRead = 'group.security.activitydefinition.read',
  ActivityDefinitionCreate = 'group.security.activitydefinition.create',
  ActivityDefinitionUpdate = 'group.security.activitydefinition.update',

  QuestionnaireRead = 'group.security.questionnaire.read',
  QuestionnaireCreate = 'group.security.questionnaire.create',
  QuestionnaireUpdate = 'group.security.questionnaire.update',

  QuestionnaireResponseRead = 'group.security.questionnaireresponse.read',
  QuestionnaireResponseCreate = 'group.security.questionnaireresponse.create',
  QuestionnaireResponseUpdate = 'group.security.questionnaireresponse.update',

  RiskAssessmentCreate = 'group.security.riskassessment.create',
  RiskAssessmentUpdate = 'group.security.riskassessment.update',
  RiskAssessmentRead = 'group.security.riskassessment.read',

  FlagCreate = 'group.security.flag.create',
  FlagUpdate = 'group.security.flag.update',
  FlagRead = 'group.security.flag.read',

  DocumentReferenceCreate = 'group.security.documentreference.create',
  DocumentReferenceUpdate = 'group.security.documentreference.update',
  DocumentReferenceRead = 'group.security.documentreference.read',
}

export const GroupDescription: Record<
  GroupSecurityValue,
  SupportedPermissionName
> = {
  [GroupSecurity.DeviceCreate]: 'Create Device',
  [GroupSecurity.DeviceRead]: 'Read Device',
  [GroupSecurity.DeviceUpdate]: 'Update Device',
  [GroupSecurity.EncounterCreate]: 'Create Encounter',
  [GroupSecurity.EncounterRead]: 'Read Encounter',
  [GroupSecurity.EncounterUpdate]: 'Update Encounter',
  [GroupSecurity.DeviceUseStatementCreate]: 'Create DeviceUseStatement',
  [GroupSecurity.DeviceUseStatementRead]: 'Read DeviceUseStatement',
  [GroupSecurity.DeviceUseStatementUpdate]: 'Update DeviceUseStatement',
  [GroupSecurity.ObservationCreate]: 'Create Observation',
  [GroupSecurity.ObservationRead]: 'Read Observation',
  [GroupSecurity.ObservationUpdate]: 'Update Observation',
  [GroupSecurity.PatientCreate]: 'Create Patient',
  [GroupSecurity.PatientRead]: 'Read Patient',
  [GroupSecurity.PatientUpdate]: 'Update Patient',
  [GroupSecurity.PatientReadAll]: 'Read All Patients',
  [GroupSecurity.PractitionerCreate]: 'Create Practitioner',
  [GroupSecurity.PractitionerRead]: 'Read Practitioner',
  [GroupSecurity.PractitionerUpdate]: 'Update Practitioner',
  [GroupSecurity.GroupCreate]: 'Create Group',
  [GroupSecurity.GroupRead]: 'Read Group',
  [GroupSecurity.GroupUpdate]: 'Update Group',
  [GroupSecurity.OrganizationCreate]: 'Create Organization',
  [GroupSecurity.OrganizationRead]: 'Read Organization',
  [GroupSecurity.OrganizationUpdate]: 'Update Organization',
  [GroupSecurity.DiagnosticReportCreate]: 'Create DiagnosticReport',
  [GroupSecurity.DiagnosticReportRead]: 'Read DiagnosticReport',
  [GroupSecurity.DiagnosticReportUpdate]: 'Update DiagnosticReport',
  [GroupSecurity.RelatedPersonCreate]: 'Create RelatedPerson',
  [GroupSecurity.RelatedPersonRead]: 'Read RelatedPerson',
  [GroupSecurity.RelatedPersonUpdate]: 'Update RelatedPerson',
  [GroupSecurity.CoverageCreate]: 'Create Coverage',
  [GroupSecurity.CoverageRead]: 'Read Coverage',
  [GroupSecurity.CoverageUpdate]: 'Update Coverage',
  [GroupSecurity.ServiceRequestCreate]: 'Create ServiceRequest',
  [GroupSecurity.ServiceRequestRead]: 'Read ServiceRequest',
  [GroupSecurity.ServiceRequestUpdate]: 'Update ServiceRequest',
  [GroupSecurity.ServiceRequestLancet]: 'Lancet pathology access',
  [GroupSecurity.MediaCreate]: 'Create Media',
  [GroupSecurity.MediaRead]: 'Read Media',
  [GroupSecurity.MediaUpdate]: 'Update Media',
  [GroupSecurity.MedicationStatementCreate]: 'Create MedicationStatement',
  [GroupSecurity.MedicationStatementRead]: 'Read MedicationStatement',
  [GroupSecurity.MedicationStatementUpdate]: 'Update MedicationStatement',
  [GroupSecurity.MedicationRequestCreate]: 'Create MedicationRequest',
  [GroupSecurity.MedicationRequestRead]: 'Read MedicationRequest',
  [GroupSecurity.MedicationRequestUpdate]: 'Update MedicationRequest',
  [GroupSecurity.MedicationRequestSignForPractitioner]:
    'Sign for practitioner MedicationRequest',
  [GroupSecurity.ClinicalImpressionCreate]: 'Create ClinicalImpression',
  [GroupSecurity.ClinicalImpressionRead]: 'Read ClinicalImpression',
  [GroupSecurity.ClinicalImpressionUpdate]: 'Update ClinicalImpression',
  [GroupSecurity.DeviceMetricCreate]: 'Create DeviceMetric',
  [GroupSecurity.DeviceMetricRead]: 'Read DeviceMetric',
  [GroupSecurity.DeviceMetricUpdate]: 'Update DeviceMetric',
  [GroupSecurity.ClaimCreate]: 'Create Claim',
  [GroupSecurity.ClaimRead]: 'Read Claim',
  [GroupSecurity.ClaimUpdate]: 'Update Claim',
  [GroupSecurity.ClaimResponseCreate]: 'Create ClaimResponse',
  [GroupSecurity.ClaimResponseRead]: 'Read ClaimResponse',
  [GroupSecurity.ClaimResponseUpdate]: 'Update ClaimResponse',
  [GroupSecurity.ChargeItemDefinitionCreate]: 'Create ChargeItemDefinition',
  [GroupSecurity.ChargeItemDefinitionRead]: 'Read ChargeItemDefinition',
  [GroupSecurity.ChargeItemDefinitionUpdate]: 'Update ChargeItemDefinition',
  [GroupSecurity.TaskCreate]: 'Create Task',
  [GroupSecurity.TaskRead]: 'Read Task',
  [GroupSecurity.TaskUpdate]: 'Update Task',
  [GroupSecurity.ChargeItemCreate]: 'Create ChargeItem',
  [GroupSecurity.ChargeItemRead]: 'Read ChargeItem',
  [GroupSecurity.ChargeItemUpdate]: 'Update ChargeItem',
  [GroupSecurity.LocationCreate]: 'Create Location',
  [GroupSecurity.LocationRead]: 'Read Location',
  [GroupSecurity.LocationUpdate]: 'Update Location',
  [GroupSecurity.ConditionCreate]: 'Create Condition',
  [GroupSecurity.ConditionRead]: 'Read Condition',
  [GroupSecurity.ConditionUpdate]: 'Update Condition',
  [GroupSecurity.CommunicationCreate]: 'Create Communication',
  [GroupSecurity.CommunicationRead]: 'Read Communication',

  [GroupSecurity.LibraryRead]: 'Read Library',
  [GroupSecurity.LibraryCreate]: 'Create Library',
  [GroupSecurity.LibraryUpdate]: 'Update Library',

  [GroupSecurity.DocumentReferenceCreate]: 'Create DocumentReference',
  [GroupSecurity.DocumentReferenceRead]: 'Read DocumentReference',
  [GroupSecurity.DocumentReferenceUpdate]: 'Update DocumentReference',

  // special permissions
  [GroupSecurity.ValueSetIcd10Read]: 'Read ValueSet ICD10',
  [GroupSecurity.FeaturePreviewNavigator]: 'Feature Preview Navigator',
  [GroupSecurity.FeaturePreviewAISearch]: 'Feature Preview AI Search',
  [GroupSecurity.FeaturePreviewNotes]: 'Feature Preview Notes',
  [GroupSecurity.VideoConsultCreate]: 'Video Consult Create',
  [GroupSecurity.VideoConsultInvite]: 'Video Consult Invite',
  [GroupSecurity.FeaturePreviewAuth0]: 'Feature Preview Auth0',
  [GroupSecurity.FeaturePreviewAI]: 'Feature Preview AI',
  [GroupSecurity.FeaturePreviewTracking]: 'Feature Preview Tracking',
  [GroupSecurity.AlertEWS]: 'Early Warning Score Alert',
  [GroupSecurity.AlertCommentRead]: 'Alert Comment Read',
  [GroupSecurity.AlertCommentCreate]: 'Alert Comment Create',
  [GroupSecurity.AlertTechRead]: 'Alert Tech Read',
  [GroupSecurity.Logistics]: 'Logistics',
  [GroupSecurity.DeviceConfigure]: 'Calibrate Device',
  [GroupSecurity.ClaimTemplateRead]: 'Read Claim Template',
  [GroupSecurity.ClaimTemplateUpdate]: 'Update Claim Template',
  [GroupSecurity.ClaimTemplateCreate]: 'Create Claim Template',
  [GroupSecurity.ClinicalImpressionSummary]: 'Clinical Impression Summary',

  [GroupSecurity.AllergyIntoleranceRead]: 'Read AllergyIntolerance',
  [GroupSecurity.AllergyIntoleranceCreate]: 'Create AllergyIntolerance',
  [GroupSecurity.AllergyIntoleranceUpdate]: 'Update AllergyIntolerance',

  [GroupSecurity.CareTeamRead]: 'Read CareTeam',
  [GroupSecurity.CareTeamCreate]: 'Create CareTeam',
  [GroupSecurity.CareTeamUpdate]: 'Update CareTeam',
  [GroupSecurity.Admin]: 'Admin tab access',

  [GroupSecurity.CarePlanRead]: 'Read CarePlan',
  [GroupSecurity.CarePlanCreate]: 'Create CarePlan',
  [GroupSecurity.CarePlanUpdate]: 'Update CarePlan',

  [GroupSecurity.PlanDefinitionRead]: 'Read PlanDefinition',
  [GroupSecurity.PlanDefinitionCreate]: 'Create PlanDefinition',
  [GroupSecurity.PlanDefinitionUpdate]: 'Update PlanDefinition',

  [GroupSecurity.ActivityDefinitionRead]: 'Read ActivityDefinition',
  [GroupSecurity.ActivityDefinitionCreate]: 'Create ActivityDefinition',
  [GroupSecurity.ActivityDefinitionUpdate]: 'Update ActivityDefinition',

  [GroupSecurity.QuestionnaireRead]: 'Read Questionnaire',
  [GroupSecurity.QuestionnaireCreate]: 'Create Questionnaire',
  [GroupSecurity.QuestionnaireUpdate]: 'Update Questionnaire',

  [GroupSecurity.QuestionnaireResponseRead]: 'Read QuestionnaireResponse',
  [GroupSecurity.QuestionnaireResponseCreate]: 'Create QuestionnaireResponse',
  [GroupSecurity.QuestionnaireResponseUpdate]: 'Update QuestionnaireResponse',

  [GroupSecurity.RiskAssessmentRead]: 'Read RiskAssessment',
  [GroupSecurity.RiskAssessmentCreate]: 'Create RiskAssessment',
  [GroupSecurity.RiskAssessmentUpdate]: 'Update RiskAssessment',

  [GroupSecurity.FlagRead]: 'Read Flag',
  [GroupSecurity.FlagCreate]: 'Create Flag',
  [GroupSecurity.FlagUpdate]: 'Update Flag',
};

export enum GroupCode {
  PractitionerClinical = 'group.code.practitioner.clinical',
  PractitionerAdministration = 'group.code.practitioner.administration',
  PractitionerTechnical = 'group.code.practitioner.technical',
  PractitionerCareCoordinator = 'group.code.practitioner.carecoordinator',
}

export const GroupCodeDescription: Record<GroupCode, string> = {
  [GroupCode.PractitionerClinical]: 'Clinical',
  [GroupCode.PractitionerAdministration]: 'Administration',
  [GroupCode.PractitionerTechnical]: 'Technical',
  [GroupCode.PractitionerCareCoordinator]: 'Care Coordinator',
};
